var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.menuList),function(item,index){return _c('div',{key:index,staticClass:"menu-father"},[_vm._v(" "+_vm._s(item.name)+" "),_c('el-menu',{staticClass:"menu",attrs:{"router":"","active-text-color":"white","default-active":0}},[_c('son-menu',{attrs:{"data":item.menu}})],1)],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }